"use client";
import React, { useEffect, useState } from "react";
import {
    Row,
    Col,
    Button,
} from "reactstrap";
import { useLocation, Link } from "react-router-dom";
import { getVendorListFormDetailById } from "../VendorNeedList/Action";
import LoaderCustom from "../../common/LoaderCustom";


const ViewUnblockRequestVendor = () => {
    const location = useLocation();
    const [loading, setLoading] = useState(false);
    const [getByIdData, setGetByIdData] = useState();

    const searchParams = new URLSearchParams(location.search);
    const vendorId = searchParams.get("VendorRequirementRegistrationId");

    useEffect(() => {
        if (vendorId) {
            setLoading(true);


            // Function to fetch data after a 3-second delay
            const fetchDataWithDelay = async () => {
                await new Promise(resolve => setTimeout(resolve, 3000));

                try {
                    const res = await getVendorListFormDetailById(vendorId);
                    const userDataPotentialsupplier = res?.Data;
                    const data = { ...userDataPotentialsupplier[0] };
                    setGetByIdData(data);

                } catch (error) {

                } finally {
                    setLoading(false);
                }
            };

            fetchDataWithDelay();
        }
    }, []);
    const handleDownload = (file) => {
        if (file) {
            // Create a hidden anchor element to trigger the download
            const link = document.createElement("a");

            if (typeof file === "string") {
                // If it's a string and starts with 'http', assume it's a URL
                link.href = file;

            } else {
                // Handle other cases or throw an error

                return;
            }

            link.target = "_blank";
            link.download = "downloadedFile";

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    };
    return (
        <div>
            <>
                {loading ? (
                    <LoaderCustom customClass="simulation-Loader loader-center hl-loader-fixed" />
                ) : (
                    ""
                )}
                <div className="hl-supplier-page">

                    <Row gutter={20} className="mb-4">
                        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                            <Row
                                className="non-registered-supplier-details-right text-left"
                                gutter={[20, 24]}
                            >
                                <Col sm={24} md={6}>
                                    <Row>
                                        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                            <h3 className="sd-common-heading">
                                                Application Details
                                            </h3>
                                        </Col>
                                    </Row>
                                    <Row className="hl-detail-column m-0">

                                        <Col
                                            xs={12}
                                            sm={6}
                                            md={6}
                                            lg={6}
                                            xl={6}
                                            className="hl-heading-details"
                                        >
                                            <span className="hl-title-details">Request Number</span>
                                        </Col>
                                        <Col
                                            xs={12}
                                            sm={6}
                                            md={6}
                                            lg={6}
                                            xl={6}
                                            className="pr-6 hl-descmain-details"
                                        >
                                            <span className="hl-desc-details">
                                                <strong>{getByIdData?.ApplicationNo || "-"}</strong>
                                            </span>
                                        </Col>

                                        <Col
                                            xs={12}
                                            sm={6}
                                            md={6}
                                            lg={6}
                                            xl={6}
                                            className="hl-heading-details"
                                        >
                                            <span className="hl-title-details">Supplier Origin</span>
                                        </Col>
                                        <Col
                                            xs={12}
                                            sm={6}
                                            md={6}
                                            lg={6}
                                            xl={6}
                                            className="pr-6 hl-descmain-details"
                                        >
                                            <span className="hl-desc-details">
                                                <strong>{getByIdData?.SupplierOriginName || "-"}</strong>
                                            </span>
                                        </Col>
                                        <Col
                                            md={6}
                                            className="hl-heading-details"
                                        >
                                            <span className="hl-title-details">Supplier Name</span>
                                        </Col>
                                        <Col
                                            md={6}
                                            className="pr-6 hl-descmain-details"
                                        >
                                            <span className="hl-desc-details">
                                                {getByIdData?.VendorName || "-"}
                                            </span>
                                        </Col>

                                        <Col
                                            md={6}
                                            className="hl-heading-details"
                                        >
                                            <span className="hl-title-details">Plant</span>
                                        </Col>
                                        <Col
                                            md={6}
                                            className="pr-6 hl-descmain-details"
                                        >
                                            <span className="hl-desc-details">
                                                {getByIdData?.PlantName || "-"}
                                            </span>
                                        </Col>
                                        <Col
                                            md={6}
                                            className="hl-heading-details"
                                        >
                                            <span className="hl-title-details">Category</span>
                                        </Col>
                                        <Col
                                            md={6}
                                            className="pr-6 hl-descmain-details"
                                        >
                                            <span className="hl-desc-details">
                                                {getByIdData?.CategoryName || "-"}
                                            </span>
                                        </Col>

                                        <Col
                                            md={6}
                                            className="hl-heading-details"
                                        >
                                            <span className="hl-title-details">Division</span>
                                        </Col>
                                        <Col
                                            md={6}
                                            className="pr-6 hl-descmain-details"
                                        >
                                            <span className="hl-desc-details">
                                                {getByIdData?.DivisionName || "-"}
                                            </span>
                                        </Col>
                                        {getByIdData?.SupplierOriginName == "Indian" &&
                                            <><Col
                                                md={6}
                                                className="hl-heading-details"
                                            >
                                                <span className="hl-title-details">
                                                    PAN No.
                                                </span>
                                            </Col><Col
                                                md={6}
                                                className="pr-6 hl-descmain-details"
                                            >
                                                    <span className="hl-desc-details">
                                                        {getByIdData?.PAN || "-"}
                                                    </span>
                                                </Col><Col
                                                    md={6}
                                                    className="hl-heading-details"
                                                >
                                                    <span className="hl-title-details">
                                                        GSTIN Number
                                                    </span>
                                                </Col><Col
                                                    md={6}
                                                    className="pr-6 hl-descmain-details"
                                                >
                                                    <span className="hl-desc-details">
                                                        {getByIdData?.GSTIN || "-"}
                                                    </span>
                                                </Col></>}
                                        <Col
                                            md={6}
                                            className="hl-heading-details"
                                        >
                                            <span className="hl-title-details">Contact Number</span>
                                        </Col>
                                        <Col
                                            md={6}
                                            className="pr-6 hl-descmain-details"
                                        >
                                            <span className="hl-desc-details">
                                                {getByIdData?.MobileNo || "-"}
                                            </span>
                                        </Col>

                                        <Col
                                            md={6}
                                            className="hl-heading-details"
                                        >
                                            <span className="hl-title-details">Primary Email Address</span>
                                        </Col>
                                        <Col
                                            md={6}
                                            className="pr-6 hl-descmain-details"
                                        >
                                            <span className="hl-desc-details">
                                                {getByIdData?.Email || "-"}
                                            </span>
                                        </Col>

                                        <Col
                                            md={6}
                                            className="hl-heading-details"
                                        >
                                            <span className="hl-title-details">Reason For blocking</span>
                                        </Col>
                                        <Col
                                            md={6}
                                            className="pr-6 hl-descmain-details"
                                        >
                                            <span className="hl-desc-details">
                                                {getByIdData?.BlockedReason || "-"}
                                            </span>
                                        </Col>
                                        <Col
                                            md={6}
                                            className="hl-heading-details"
                                        >
                                            <span className="hl-title-details">Expected Business/Year(INR)</span>
                                        </Col>
                                        <Col
                                            md={6}
                                            className="pr-6 hl-descmain-details"
                                        >
                                            <span className="hl-desc-details">
                                                {getByIdData?.ExpectedBusiness || "-"}
                                            </span>
                                        </Col>


                                        <Col
                                            md={6}
                                            className="hl-heading-details"
                                        >
                                            <span className="hl-title-details">Payment Terms</span>
                                        </Col>
                                        <Col
                                            md={6}
                                            className="pr-6 hl-descmain-details"
                                        >
                                            <span className="hl-desc-details">
                                                {getByIdData?.PaymentTermsName || "-"}
                                            </span>
                                        </Col>
                                    </Row>

                                </Col>
                                <Col sm={24} md={6}>
                                    <Row>
                                        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                            <h3 className="sd-common-heading">
                                                Why Supplier Unblocking is Required
                                            </h3>
                                        </Col>
                                    </Row>
                                    <Row className="hl-detail-column m-0">
                                        {/* <Col
                                            md={6}
                                            className="hl-heading-details"
                                        >
                                            <span className="hl-title-details">
                                               Commercial Reason
                                            </span>
                                        </Col> */}

                                        <Col
                                            md={6}
                                            className="hl-descmain-details"
                                        >
                                            <span className="hl-title-details">
                                                Import localization
                                            </span>
                                        </Col>
                                        <Col
                                            md={6}
                                            className="pr-6 hl-descmain-details"
                                        >
                                            <span className="hl-desc-details">
                                                {getByIdData?.ImportlocalizationName}
                                            </span>
                                        </Col>
                                        <Col
                                            md={6}
                                            className="hl-heading-details"
                                        >
                                            <span className="hl-title-details">
                                                Due to Single Source
                                            </span>
                                        </Col>
                                        <Col
                                            md={6}
                                            className="pr-6 hl-descmain-details"
                                        >
                                            <span className="hl-desc-details">
                                                {getByIdData?.DuetoSingleSourceName}
                                            </span>
                                        </Col>
                                        {getByIdData?.CommercialText && (<><Col
                                            md={6}
                                            className="hl-descmain-details"
                                        >
                                            <span className="hl-title-details">
                                                Commercial Reason
                                            </span>
                                        </Col><Col md={6} className="pr-6 hl-descmain-details">
                                                <span className="hl-desc-details">
                                                    {getByIdData.CommercialText}
                                                </span>
                                            </Col></>
                                        )}
                                        {getByIdData?.CommercialText == "Yes" && (
                                            <>
                                                <Col
                                                    xs={24}
                                                    sm={12}
                                                    md={12}
                                                    lg={12}
                                                    xl={12}
                                                    className="hl-heading-details"
                                                >
                                                    <span className="hl-title-details">
                                                        Reason
                                                    </span>
                                                </Col>
                                                <Col
                                                    xs={24}
                                                    sm={12}
                                                    md={12}
                                                    lg={12}
                                                    xl={12}
                                                    className="pr-6 hl-descmain-details"
                                                >
                                                    <span className="hl-desc-details">
                                                        {getByIdData?.CommercialReasonName}
                                                    </span>
                                                </Col>
                                            </>)}

                                        {getByIdData?.CostSavingName && (
                                            <>
                                                <Col
                                                    xs={24}
                                                    sm={12}
                                                    md={12}
                                                    lg={12}
                                                    xl={12}
                                                    className="hl-descmain-details"
                                                >
                                                    <span className="hl-title-details">
                                                        Cost Saving
                                                    </span>
                                                </Col>
                                                <Col
                                                    xs={24}
                                                    sm={12}
                                                    md={12}
                                                    lg={12}
                                                    xl={12}
                                                    className="pr-6 hl-descmain-details"
                                                >
                                                    <span className="hl-desc-details">
                                                        {getByIdData?.CostSavingName || "-"}
                                                    </span>
                                                </Col>
                                            </>
                                        )}

                                        {getByIdData?.CostSavingName == "Yes" && (
                                            <>
                                                <Col
                                                    xs={24}
                                                    sm={12}
                                                    md={12}
                                                    lg={12}
                                                    xl={12}
                                                    className="hl-heading-details"
                                                >
                                                    <span className="hl-title-details">
                                                        How Much Annually?
                                                    </span>
                                                </Col>
                                                <Col
                                                    xs={24}
                                                    sm={12}
                                                    md={12}
                                                    lg={12}
                                                    xl={12}
                                                    className="pr-6 hl-descmain-details"
                                                >
                                                    <span className="hl-desc-details">
                                                        {getByIdData?.HowMuchAnnuallyCostSaving} Lakh
                                                    </span>
                                                </Col>

                                                <Col
                                                    xs={24}
                                                    sm={12}
                                                    md={12}
                                                    lg={12}
                                                    xl={12}
                                                    className="hl-heading-details"
                                                >
                                                    <span className="hl-title-details">
                                                        What Percent Annually?
                                                    </span>
                                                </Col>
                                                <Col
                                                    xs={24}
                                                    sm={12}
                                                    md={12}
                                                    lg={12}
                                                    xl={12}
                                                    className="pr-6 hl-descmain-details"
                                                >
                                                    <span className="hl-desc-details">
                                                        {getByIdData?.WhatPercentAnnuallyCostSaving}%
                                                    </span>
                                                </Col>
                                            </>
                                        )}

                                        {getByIdData?.CostSavingDocumentUrl && (
                                            <>
                                                <Col
                                                    xs={24}
                                                    sm={12}
                                                    md={12}
                                                    lg={12}
                                                    xl={12}
                                                    className="hl-heading-details"
                                                >
                                                    <span className="hl-title-details">
                                                        Upload Evidence
                                                    </span>
                                                </Col>
                                                <Col
                                                    xs={24}
                                                    sm={12}
                                                    md={12}
                                                    lg={12}
                                                    xl={12}
                                                    className="pr-6 hl-descmain-details"
                                                >
                                                    <span className="hl-desc-details text-uppercase justify-content-end pr-0">
                                                        <Button
                                                            className="hl-upload-btn hl-mb-0"
                                                            title="Download"
                                                            onClick={() => {
                                                                handleDownload(
                                                                    getByIdData?.CostSavingDocumentUrl
                                                                );
                                                            }}
                                                            disabled={false}
                                                        >
                                                            <div className="download mr-0"></div>
                                                        </Button>
                                                    </span>
                                                </Col>
                                            </>
                                        )}
                                        {getByIdData?.CostSheetName && (
                                            <>
                                                <Col
                                                    xs={24}
                                                    sm={12}
                                                    md={12}
                                                    lg={12}
                                                    xl={12}
                                                    className="hl-descmain-details">
                                                    <span className="hl-title-details">Cost Sheet</span>
                                                </Col>
                                                <Col
                                                    xs={24}
                                                    sm={12}
                                                    md={12}
                                                    lg={12}
                                                    xl={12}
                                                    className="pr-6 hl-descmain-details">
                                                    <span className={`hl-desc-details justify-content-between pr-0 ${getByIdData?.CostSheetName === "No" ? " " : ""}`}>
                                                        {getByIdData?.CostSheetName}
                                                        {getByIdData?.CostSheetDocumentUrl && (
                                                            <Button
                                                                className="hl-upload-btn hl-mb-0"
                                                                title="Download"
                                                                onClick={() => {
                                                                    handleDownload(
                                                                        getByIdData?.CostSheetDocumentUrl
                                                                    );
                                                                }}
                                                                disabled={false}
                                                            >
                                                                <div className="download mr-0"></div>
                                                            </Button>
                                                        )}
                                                    </span>
                                                </Col>
                                            </>
                                        )}
                                        <Col md={6} className="hl-heading-details">
                                            <span className="hl-title-details">Why Supplier Unblocking is Required</span>
                                        </Col>
                                        <Col
                                            md={6}
                                            className="pr-6 hl-descmain-details"
                                        >
                                            <span className="hl-desc-details">
                                                {getByIdData?.WhyVendorUnblockRemark}
                                            </span>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </div>
            </>
        </div>
    );
};

export default ViewUnblockRequestVendor;
